import { render, staticRenderFns } from "./shopDelete.vue?vue&type=template&id=425ef53e&"
import script from "./shopDelete.vue?vue&type=script&lang=js&"
export * from "./shopDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports